import axiosInstance from "@/api/axios-instance";

export interface OrphanedSession {
  id: string;
  invitee_full_name: string | null;
  invitee_email: string | null;
  invitee_phone: string | null;
  start_time: string;
  status: string;
  usage_identifier: string | null;
  is_linked_elsewhere: boolean;
}

export interface OrphanedSessionsResponse {
  sessions: OrphanedSession[];
}

export async function getOrphanedSessions(
  bundleUsageId: string
): Promise<OrphanedSessionsResponse> {
  const response = await axiosInstance.get(
    `/audit/orphaned-sessions/${bundleUsageId}`
  );
  return response.data;
}
